$(".js-newsletter").submit(function(e){
    e.preventDefault();

    var frm = $(this);
    var data = frm.serialize();
    frm.find(".js-wait").removeAttr("hidden");
    frm.find(".js-submit").attr("hidden","");
    frm.find(".js-message").attr("hidden","");
    $.post(
        ajaxurl,
        {
            'action': 'ajaxmailjet',
            'data': data
        },
        function(response){
            console.log(response);

            frm.find(".js-wait").attr("hidden","");
            frm.find(".js-submit").removeAttr("hidden");
            var result = JSON.parse(response);
            if( result.status == "error" ){
                frm.find(".js-message")
                .removeAttr("hidden")
                .html(result.message)
                .removeClass("alert--success")
                .removeClass("alert--warning")
                .addClass("alert--error");
            }
            if( result.status == "success" ){
                frm.find(".js-message")
                .removeAttr("hidden")
                .html(result.message)
                .removeClass("alert--error")
                .removeClass("alert--warning")
                .addClass("alert--success");
            }
            if( result.status == "warning" ){
                frm.find(".js-message")
                .removeAttr("hidden")
                .html(result.message)
                .removeClass("alert--success")
                .removeClass("alert--error")
                .addClass("alert--warning");
            }
        }
    );


    return false;
});